import React from "react";
import { FaClock, FaMapMarkerAlt, FaUserTie } from "react-icons/fa";

import {
  cn,
  getHexColor,
  isDark,
  isGroupFull,
  lighten,
  teachersOf,
} from "./groupPlanningUtils";

export default function PlanningChip({ cours, dojoName, onOpen }) {
  const baseColor = getHexColor(cours.color_groupe);
  const lightColor = lighten(baseColor, 0.65);
  const textColor = isDark(baseColor) ? "#fff" : "#0f172a";
  const full = isGroupFull(cours);
  const teachers = teachersOf(cours);

  return (
    <button
      type="button"
      onClick={() => onOpen(cours)}
      className={cn(
        "group relative w-full overflow-hidden rounded-3xl text-left shadow-sm",
        "border border-white/60 transition hover:-translate-y-1 hover:shadow-xl",
        "dark:border-white/10"
      )}
      style={{
        background: `linear-gradient(135deg, ${baseColor} 0%, ${lightColor} 100%)`,
        color: textColor,
      }}
      title="Voir les détails"
    >
      <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-white/20 blur-2xl" />

      {full && (
        <span className="absolute right-3 top-3 rounded-full bg-rose-600 px-2.5 py-1 text-[10px] font-bold uppercase text-white shadow">
          Complet
        </span>
      )}

      <div className="relative p-4">
        <div className="flex flex-wrap gap-2">
          <span className="inline-flex items-center gap-1 rounded-full bg-white/60 px-2.5 py-1 text-[11px] font-bold text-slate-900">
            <FaClock />
            {cours.horaire}
          </span>

          {cours.discipline_groupe && (
            <span className="rounded-full bg-white/60 px-2.5 py-1 text-[11px] font-bold text-slate-900">
              {cours.discipline_groupe}
            </span>
          )}
        </div>

        <h4 className="mt-4 font-barlow text-xl font-extrabold uppercase leading-tight">
          {cours.nom}
        </h4>

        {cours.annees_naissance && (
          <p className="mt-1 text-xs font-bold italic opacity-90">
            {cours.annees_naissance}
          </p>
        )}

        <div className="mt-4 space-y-1 text-xs font-semibold opacity-90">
          <p className="flex items-center gap-2">
            <FaMapMarkerAlt />
            {dojoName || "-"}
          </p>

          <p className="flex items-center gap-2">
            <FaUserTie />
            {teachers.slice(0, 2).join(" • ") || "-"}
            {teachers.length > 2 ? " …" : ""}
          </p>
        </div>
      </div>
    </button>
  );
}